import {BaseAppModel} from "./AppModel";
import MqttEventWrapper, {MqttEventType} from "./MqttEventWrapper";
import {MqttClientType} from "@/module/mqtt/MqttClientType";
import {MessagePublishEvent} from "@/module/mqtt/MessagePublishEvent";
import {InstrUtil} from "@/module/mqtt/Instruction";
import InstrTmpl from "@/module/instr/InstrTmpl";

export default class DeviceMqttEventWrapper extends BaseAppModel<DeviceMqttEventWrapper> {
    deviceId!: number
    eventType!: MqttEventType
    mqttEventWrapper!: MqttEventWrapper
    clientType!: MqttClientType
}

export function findTmpl(wrapper: DeviceMqttEventWrapper, map: Map<number, InstrTmpl>): InstrTmpl | undefined {
    if (wrapper.eventType != MqttEventType.MESSAGE_PUBLISH) return undefined
    const event = wrapper.mqttEventWrapper.event as MessagePublishEvent
    const payload = event.payload
    const instr = InstrUtil.parseFromMessageBody(payload)
    return map.get(instr.funId)
}
